<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import {USER_ROLE} from "../lib/constants.js";

    export let userId = null;
    export let closeCallback;

    let user = null;
    let hotels = [];
    let changePassword = false;
    let roles = [
        {role: 1, name: 'Administrator'},
        {role: 2, name: 'Receptionist'},
        {role: 0, name: 'User'}
    ];

    const initialize = () => {
        const onSuccess = result => {
            hotels = result.hotels;
            if (userId === 0) {
                user = {
                    id: 0,
                    role_id: USER_ROLE.USER,
                    hotel_id: null,
                    name: '',
                    email: '',
                    password: '',
                }
                setFocusTo('userName');
            } else {
                user = result.user;
                user.role_id = ~~user.role_id;
            }
            setFocusTo('userName');
        };

        const onFailure = err => {
        };

        R.handle(R.user.initialize, (userId === 0 ? 'new' : userId), onSuccess, onFailure, LOADER.POPUP);
    }

    // const load = () => {
    //
    //     const onSuccess = result => {
    //         user = result;
    //         user.role_id = ~~user.role_id;
    //         setFocusTo('userName');
    //     };
    //
    //     const onFailure = err => {
    //     };
    //
    //     R.handle(R.user.details, userId, onSuccess, onFailure, LOADER.POPUP);
    // };


    const save = () => {
        const onSuccess = result => {
            if (userId == 0) {
                Notifier.showMessage("User account created");
            } else {
                Notifier.showMessage("User account updated");
            }
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
                if (err.code == 'user_account_exist') {
                    setFocusTo("userEmail");
                }
            }
        };


        user.name = user.name.trim();
        user.email = user.email.trim();
        if (!user.name) {
            Notifier.showError("Type the name of the user");
            setFocusTo("userName");
            return;
        }
        if (!user.email) {
            Notifier.showError("Enter the account email");
            setFocusTo("userEmail");
            return;
        }
        if (user.role_id == USER_ROLE.RECEPTIONIST && !user.hotel_id) {
            Notifier.showError("Select the hotel of this user");
            setFocusTo("userHotel");
            return;
        }
        if (user.id === 0 && !user.password) {
            Notifier.showError("Enter the account password");
            setFocusTo("password");
            return;
        }
        if (changePassword && !user.password) {
            Notifier.showError("Enter the new password");
            setFocusTo("newPassword");
            return;
        }

        if (user.id > 0 && !changePassword) {
            delete (user.password);
        }

        let action = userId === 0 ? 'create' : 'edit';
        R.handle(R.user[action], user, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        user = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const toggleChangePassword = () => {
        changePassword = !changePassword;
        if (changePassword) {
            setFocusTo("newPassword");
        } else {
            delete (user.password);
        }
    }

    initialize();
</script>

{#if user}
    <Modal title="User account" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="userName" bind:value="{ user.name }">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="userEmail" bind:value="{ user.email }">
            </div>
            {#if user.id == 0}
                <div class="form-group">
                    <label>Password</label>
                    <input type="text" class="form-control" id="password" bind:value="{ user.password }">
                </div>
            {:else}
                {#if !changePassword}
                    <div class="form-group">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Change password
                        </button>
                    </div>
                {:else}
                    <div class="form-group">
                        <label>New password</label>
                        <input type="text" class="form-control" id="newPassword" bind:value="{ user.password }">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Do not change password
                        </button>
                    </div>
                {/if}
            {/if}
            <div class="form-group">
                <label>Account type</label>
                <select class="form-select" bind:value="{ user.role_id }" disabled="{ user.id == 1 }">
                    {#each roles as item}
                        <option value="{ item.role }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            {#if user.role_id == USER_ROLE.RECEPTIONIST}
                <div class="form-group">
                    <label>Hotel</label>
                    <select class="form-select" id="userHotel" bind:value="{ user.hotel_id }">
                        {#each hotels as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}